import { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

const SubscriptionReturn = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { refreshAccess } = useAuth();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const sid = params.get("subscription_id");
    if (!sid) {
      navigate("/upgrade");
      return;
    }
    api.get(`/subscription/verify?subscription_id=${encodeURIComponent(sid)}`)
      .then(async () => {
        toast.success("Subscription confirmed. Welcome to Premium.");
        await refreshAccess();
        navigate("/dashboard", { replace: true });
      })
      .catch(() => {
        toast.error("Could not verify subscription. Please contact support.");
        navigate("/upgrade", { replace: true });
      });
  }, [params, navigate, refreshAccess]);

  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="subscription-return">
      <div className="text-center">
        <Loader2 className="w-8 h-8 animate-spin text-amber-500 mx-auto mb-3" />
        <p className="text-neutral-400">Confirming your subscription…</p>
      </div>
    </div>
  );
};

export default SubscriptionReturn;
